/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


export const styles:any[] = [''];
//# sourceMappingURL=data:application/json;base64,eyJmaWxlIjoiRTovd2FtcDY0L3d3dy9oZWxwZGVzay9jbGllbnQvc3JjL2FwcC91c2VyL2VtYWlsLWFkZHJlc3MtbW9kYWwvZW1haWwtYWRkcmVzcy1tb2RhbC5jb21wb25lbnQuc2Nzcy5uZ3N0eWxlLnRzIiwidmVyc2lvbiI6Mywic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsibmc6Ly8vRTovd2FtcDY0L3d3dy9oZWxwZGVzay9jbGllbnQvc3JjL2FwcC91c2VyL2VtYWlsLWFkZHJlc3MtbW9kYWwvZW1haWwtYWRkcmVzcy1tb2RhbC5jb21wb25lbnQuc2NzcyJdLCJzb3VyY2VzQ29udGVudCI6WyIgIl0sIm1hcHBpbmdzIjoiQUFBQTs7Ozs7Ozs7In0=



// WEBPACK FOOTER //
// E:/wamp64/www/helpdesk/client/src/$$_gendir/app/user/email-address-modal/email-address-modal.component.scss.ngstyle.ts